module.exports = __webpack_public_path__ + "a2050abbc10430225cec1e60fd2af2e4.mp3";